import { defineMessages } from 'react-intl';

const messages = defineMessages({
  hire: {
    id: 'app.components.MoveApplicantDialog.hire',
    defaultMessage: 'Hire',
  },
  jobStageSelectorLabel: {
    id: 'app.components.MoveApplicantDialog.jobStageSelectorLabel',
    defaultMessage:
      'You are moving <b>{applicantCount, plural, one {{applicantName}} other {{applicantCount} applicants}}</b> to <b>{stageName}</b>',
  },
  jobStageSelectorLabelViaRuleStage: {
    id: 'app.components.MoveApplicantDialog.jobStageSelectorLabelViaRuleStage',
    defaultMessage:
      'You are moving <b>{applicantCount, plural, one {{applicantName}} other {{applicantCount} applicants}}</b> to <b>{stageName}</b> via <b>{ruleStage}</b>',
  },
  jobStageSelectorLabelViaBulkRuleStage: {
    id: 'app.components.MoveApplicantDialog.jobStageSelectorLabelViaBulkRuleStage',
    defaultMessage:
      'You are bulk moving <b>{applicantCount}</b> applicants to {ruleStage}, a rule stage that may prescribe different actions to your selected group. The below describes the expected actions for the first applicant in the selected group.',
  },
  dataValidationWarningMessage: {
    id: 'app.components.MoveApplicantDialog.dataValidationWarningMessage',
    defaultMessage: 'Bulk moving applicants will ignore data validations',
  },
  jobStageSelectorLabelNoneSelected: {
    id: 'app.components.MoveApplicantDialog.jobStageSelectorLabelNoneSelected',
    defaultMessage: 'You must select a <b>Job</b> and a <b>Stage</b>',
  },
  moveApplicantToJob: {
    id: 'app.components.MoveApplicantDialog.moveApplicantToJob',
    defaultMessage:
      'Move {applicantCount, plural, one {Applicant} other {{applicantCount} Applicants}}',
  },
  moveApplicantToNextStage: {
    id: 'app.components.MoveApplicantDialog.moveApplicantToNextStage',
    defaultMessage:
      'Advance {applicantCount, plural, one {Applicant} other {{applicantCount} Applicants}}',
  },
  moveApplicantToOnHold: {
    id: 'app.components.MoveApplicantDialog.moveApplicantToOnHold',
    defaultMessage:
      'Move {applicantCount, plural, one {Applicant} other {{applicantCount} Applicants}} to On Hold',
  },
  moveApplicantToReject: {
    id: 'app.components.MoveApplicantDialog.moveApplicantToReject',
    defaultMessage:
      'Move {applicantCount, plural, one {Applicant} other {{applicantCount} Applicants}} to Rejected',
  },
  moveApplicantToHired: {
    id: 'app.components.MoveApplicantDialog.moveApplicantToHired',
    defaultMessage:
      'Move {applicantCount, plural, one {Applicant} other {{applicantCount} Applicants}} to Hired',
  },
  moveApplicantToStage: {
    id: 'app.components.MoveApplicantDialog.moveApplicantToStage',
    defaultMessage:
      'Move {applicantCount, plural, one {Applicant} other {{applicantCount} Applicants}}',
  },
  otherReason: {
    id: 'app.components.MoveApplicantDialog.otherReason',
    defaultMessage: 'Other Reason',
  },
  onHoldReason: {
    id: 'app.components.MoveApplicantDialog.onHoldReason',
    defaultMessage: 'Reason (Optional)',
  },
  rejectReason: {
    id: 'app.components.MoveApplicantDialog.rejectReason',
    defaultMessage: 'Reason',
  },
  reject: {
    id: 'app.components.MoveApplicantDialog.reject',
    defaultMessage: 'Reject',
  },
  selectReason: {
    id: 'app.components.MoveApplicantDialog.selectReason',
    defaultMessage: 'Select a Reason',
  },
  selectReasonHelperText: {
    id: 'app.components.MoveApplicantDialog.selectReasonHelperText',
    defaultMessage:
      "The applicant's existing rejection reasons will be retained if no reason is selected",
  },
  submit: {
    id: 'app.components.MoveApplicantDialog.submit',
    defaultMessage: 'Submit',
  },
  blockMessage: {
    id: 'app.components.MoveApplicantDialog.blockMessage',
    defaultMessage:
      'Cannot bulk move applicants into stages that require manual data validation.',
  },
  bulkSelectAllNeedsStage: {
    id: 'app.components.MoveApplicantDialog.bulkSelectAllNeedsStage',
    defaultMessage: 'Open a single stage to select all of its applicants.',
    description:
      'Error shown when a recruiter selects every applicant without first choosing one hiring stage, so the action is not run',
  },
  bulkListChanged: {
    id: 'app.components.MoveApplicantDialog.bulkListChanged',
    defaultMessage:
      'This list changed since it loaded. Refresh the page and try again.',
    description:
      'Error shown when applicants changed stage after the list was loaded, so the bulk action is not run',
  },
});

export default messages;
